<template>
    <Card :no-border="false">
        <template #header>
            <div class="card-header">
                <h4>预警设置</h4>
                <div class="buttons">
                    <el-button icon="el-icon-edit-outline" size="mini" type="warning" @click="showAdd = true">新增规则 </el-button>
                </div>
            </div>
        </template>
        <div style="padding: 10px">
            <el-table size="mini" :data="data">
                <el-table-column type="index" label="序号"> </el-table-column>
                <el-table-column prop="PolicyName" label="规则名称"></el-table-column>
                <el-table-column label="日期">
                    <template #default="{ row }">
                        {{ getDate(row) }}
                    </template>
                </el-table-column>
                <el-table-column prop="MaxFlow" label="客流阈值"></el-table-column>
                <el-table-column prop="MinInterval" label="最小预警频率(分钟)"></el-table-column>
                <el-table-column width="150px" label="操作">
                    <template #default="{ row }">
                        <el-button @click="onRemove(row.PolicyID)" size="mini" type="danger">移除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <FlowWarnPolicyAdd @save="onSave" @close="showAdd = false" :show="showAdd" v-if="showAdd"></FlowWarnPolicyAdd>
        </div>
    </Card>
</template>
<script>
import FlowWarnPolicyAdd from "./FlowWarnPolicyAdd.vue";
export default {
    name: "FlowWarnPolicy",
    components: { FlowWarnPolicyAdd },
    props: {
        id: { type: String },
    },
    watch: {
        id(v) {
            if (v) {
                this.loadData(v);
            }
        },
    },
    mounted() {
        this.loadData(this.id);
    },
    data() {
        return {
            showAdd: false,
            data: [],
        };
    },
    methods: {
        loadData(id) {
            this.$ajax.post("/Entity/GetFlowWarnPolicy?id=" + id).then((r) => {
                this.data = r.Data;
            });
        },
        onSave(e) {
            e.EntityID = this.id;
            this.$ajax.post("/Entity/AddFlowWarnPolicy", e).then((r) => {
                this.loadData(this.id);
                this.showAdd = false;
            });
        },
        onRemove(id) {
            this.$myConfirm().then(() => {
                this.$ajax.post("/Entity/RemoveFlowWarnPolicy?id=" + id).then((r) => {
                    this.loadData(this.id);
                    this.$success("删除成功");
                });
            });
        },
        getDate(row) {
            switch (row.DateType) {
                case 1:
                    return "每天";
                case 2:
                    return "节假日";
                case 3:
                    return "工作日";
                case 4: {
                    try {
                        let arr = row.DateValue;
                        let str = "";
                        for (let i = 0; i < arr.length; i++) {
                            switch (parseInt(arr[i], 10)) {
                                case 0:
                                    str += "星期日,";
                                    break;
                                case 1:
                                    str += "星期一,";
                                    break;
                                case 2:
                                    str += "星期二,";
                                    break;
                                case 3:
                                    str += "星期三,";
                                    break;
                                case 4:
                                    str += "星期四,";
                                    break;
                                case 5:
                                    str += "星期五,";
                                    break;
                                case 6:
                                    str += "星期六,";
                                    break;
                                default:
                                    break;
                            }
                        }
                        if (str.length > 0) {
                            str = str.substr(0, str.length - 1);
                        }
                        return str;
                    } catch (e) {
                        return "-";
                    }
                }
                case 5: {
                    try {
                        return row.DateValue[0] + "~" + row.DateValue[1];
                    } catch (e) {
                        return "";
                    }
                }
                default:
                    return "-";
            }
        },
    },
};
</script>
